var map = {
	"./clutch.jpg": 99696,
	"./elijah.png": 85725,
	"./elmer.png": 15238,
	"./george.png": 3698,
	"./good.jpg": 14723,
	"./google.jpg": 73306,
	"./johan.png": 99622,
	"./next.png": 79624,
	"./oliver.png": 37999,
	"./prev.png": 14537,
	"./review-pphn.jpg": 39858,
	"./top.jpg": 72883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84326;